import React from 'react';
import { Card, CardBody, Form } from 'react-bootstrap';

function TruckingToRig({ 
  truckingToRig, 
  handleRigChange, 
  templateId,
  inputOptionList,
  handleInputSelect
}) {
    return (
        <>
            <Card className="mb-3 card-height-equal">
                <CardBody>
                    <div className="mt-wap--gtr">
                        <h3 className="heading-yt-wp">
                            Trucking to Rig
                        </h3>
                        <div className="form-card--lyt">
                            <Form>
                                <Form.Group className="mb-3" controlId="">
                                    <Form.Label className="label-txt-vl">
                                        Company{" "}
                                        <span style={{ color: "red" }}>*</span>
                                    </Form.Label>
                                    <div className="filed-group-control">
                                        <Form.Control
                                             disabled={templateId ? localStorage.role == 'Admin' ? false : true : false} 
                                            onChange={handleRigChange}
                                            name="company"
                                            value={truckingToRig.company}
                                            type="text"
                                            placeholder="Input Company"
                                            className="input-vt-text"
                                        />
                                    </div>
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="">
                                    <Form.Label className="label-txt-vl">
                                        Driver Name{" "}
                                        <span style={{ color: "red" }}>*</span>
                                    </Form.Label>
                                    <div className="filed-group-control">
                                        <Form.Control
                                             disabled={templateId ? localStorage.role == 'Admin' ? false : true : false} 
                                            onChange={handleRigChange}
                                            name="driverName"
                                            value={truckingToRig.driverName}
                                            type="text"
                                            placeholder="Input Name"
                                            className="input-vt-text"
                                        />
                                    </div>
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="">
                                    <Form.Label className="label-txt-vl">
                                        Phone Number{" "}
                                        <span style={{ color: "red" }}>*</span>
                                    </Form.Label>
                                    <div className="filed-group-control">
                                        <Form.Control
                                             disabled={templateId ? localStorage.role == 'Admin' ? false : true : false} 
                                            onChange={handleRigChange}
                                            name="phone"
                                            value={truckingToRig.phone}
                                            type="text"
                                            placeholder="Input Phone"
                                            className="input-vt-text"
                                        />
                                    </div>
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="">
                                    <Form.Label className="label-txt-vl">
                                        Bill of Lading Number (BOL)
                                    </Form.Label>
                                    <div className="filed-group-control">
                                        <Form.Control
                                             disabled={templateId ? localStorage.role == 'Admin' ? false : true : false} 
                                            onChange={handleRigChange}
                                            name="bol"
                                            value={truckingToRig.bol}
                                            type="text"
                                            placeholder="Input BOL"
                                            className="input-vt-text"
                                        />
                                    </div>
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="">
                                    <Form.Label className="label-txt-vl">
                                        Pay for the Truck
                                    </Form.Label>
                                    <div className="filed-group-control">
                                        <Form.Control
                                            disabled={templateId ? localStorage.role == 'Admin' ? false : true : false} 
                                            onChange={handleRigChange}
                                            name="payforTruck"
                                            value={truckingToRig.payforTruck}
                                            type="text"
                                            placeholder="Input Pay"
                                            className="input-vt-text"
                                        />
                                    </div>
                                </Form.Group>
                                <Form.Group controlId="">
                                    <Form.Label className="label-txt-vl">
                                        S3S PO#
                                    </Form.Label>
                                    <div className="filed-group-control">
                                        <Form.Control
                                            disabled={templateId ? localStorage.role == 'Admin' ? false : true : false} 
                                            onChange={handleRigChange}
                                            name="po"
                                            value={truckingToRig.po}
                                            type="text"
                                            placeholder="Input Po"
                                            className="input-vt-text"
                                        />
                                    </div>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                </CardBody>
            </Card>
        </>
    );
}

export default TruckingToRig;